<template>
  <l-container>
    <l-container-title slot="toolbar" text="Converted timeseries" icon="stream" color="bg-pastel-green-500" />
    <div class="w-full flex flex-col">
      <div class="flex mt-4 w-full">
        <div class="w-2/3">
          <l-select v-model="networkSelection" class="text-xs" :data="networks" placeholder="Please select a network" :multiple="false" >
            <l-option v-for="i in networks" :key="i.label" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>
        </div>
        <div class="w-1/3 ml-2 mr-2">
          <l-button type="success" :disabled="networkSelection == null" @click="onClick">
            Show converted timeserie
          </l-button>
        </div>   
      </div>
    </div>
  </l-container>
</template>
<script>
import { LSelect, LOption, LButton } from "@/components/forms";

export default {
  name: "LLSelection",
  components: {
    LSelect,
    LOption,
    LButton
  },
  props: ["networks"],
  data() {
    return {
      networkSelection: null
    };
  },  
  methods: {
    onClick() {
      this.$emit("click",this.networkSelection);
    }
  }
};
</script>